import script from "./PlatformNotification.vue?vue&type=script&setup=true&lang=js"
export * from "./PlatformNotification.vue?vue&type=script&setup=true&lang=js"

import "./PlatformNotification.vue?vue&type=style&index=0&id=25b7d55f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25b7d55f"]])

export default __exports__